import 'slick-carousel';
import 'magnific-popup';

$(function () {
  $('#about_level').click(function () {
    $.magnificPopup.open({
      items: {src: '#pop_level_introduction'},
      type: 'inline',
      fixedContentPos: true,
      callbacks: {
        open: function () {
          if ($('.slider').hasClass('slick-initialized')) {
            $('.slider').slick('unslick');
          }
          $('.slider').slick({
            dots: true,
            pauseOnHover: false,
            pauseOnDotsHover: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            swipe: false,
          });
        },
        afterClose: function () {
          $('.slider').slick('unslick');
        }
      }
    }, 0);
  });

  $(document).on('afterChange', '.slider', function () {
    if ($('.slick-next').attr('aria-disabled') == 'true') {
      $('.slick-next').data('end-page', true);
    } else {
      $('.slick-next').data('end-page', false);
    }
  });

  $(document).on('click', '.slick-next', function () {
    if ($('.slick-next').data('end-page')) {
      $.magnificPopup.close();
    }
  });

});
